import type { RouteRecordRaw } from "vue-router";

export const routes: RouteRecordRaw[] = [
  {
    path: "/clubs",
    name: "clubs.index",
    component: () => import("@/modules/clubs/views/IndexView.vue"),
    meta: {
      requiresAuth: true,
    },
  },
];
